import { ProductProviderEnum } from './../../core/enum/productProvider';
import {Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import { Store, select } from '@ngrx/store';
import {BehaviorSubject, Observable, of, Subject, Subscription} from 'rxjs';
import * as searchActions from "@app/marketplace/products/state/product-search/search-actions";
import * as searchSelectors from '@app/marketplace/products/state/product-search/search-selectors';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { FormControl } from '@angular/forms';
import {debounceTime, distinctUntilChanged, take, takeUntil} from 'rxjs/operators';
import {StorageService} from '@app/services/storage.service';
import {ActivatedRoute, Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {environment} from '@env/environment';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AmazonWizardComponent} from '@app/marketplace/layout/search/amazon-wizard/amazon-wizard.component';
import {ActivePerfRecorder} from '@angular/compiler-cli/src/ngtsc/perf';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit, OnDestroy {
  provider$: Observable<any>;
  term$: Observable<any>;
  searhControl = new FormControl("");
  protected _subscriptions: Subscription[] = [];
  unsubscribe = new Subject();
  stop = false;
  provider;
  showMegaMenuSubject = new BehaviorSubject({});
  showMegaMenu$ = this.showMegaMenuSubject.asObservable();

  turnOnShein = environment.turn_on_shein;
  turnOnAmazon = environment.turn_on_amazon;
  turnOnWalmart = environment.turn_on_walmart;
  turnOnHomeDepot= environment.turn_on_homedepot;
  turnOnBestBuy= environment.turn_on_bestbuy;

  constructor(private store: Store<any>,
    public storageService: StorageService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    @Inject(PLATFORM_ID) private platformId,
    @Inject(DOCUMENT) private document) {
      this.provider$ = this.store.select(searchSelectors.selectProvider);
      this.term$ = this.store.select(searchSelectors.selectTerm);
  }
  async ngOnInit(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      this._subscriptions.push(this.searhControl.valueChanges
        .pipe(debounceTime(250), distinctUntilChanged())
        .subscribe(async (val) => {
          const provider = await this.store.pipe(select(searchSelectors.selectProvider), take(1)).toPromise();
            this.store.dispatch(searchActions.KeyPressInSearch({term: val}));
            if (val.length===0 && provider==0)
              this.store.dispatch(searchActions.SearchProducts());
        }));
      this.route.queryParams.subscribe(result => {
        if (result && result.stu_provider && (result.stu_provider == '1' || result.stu_provider == '0' || result.stu_provider == '2' || result.stu_provider == '3' || result.stu_provider == '4'|| result.stu_provider == '5')) {
          this.store.dispatch(searchActions.SetProvider({provider: result.stu_provider}));
        }
      });
      if (environment.turn_on_walmart || environment.turn_on_bestbuy || environment.turn_on_homedepot || environment.turn_on_shein || environment.turn_on_amazon) {
        this.showWizard();
      }
    }
  }

  getRandomInt(): number {
    let provider =  Math.floor(Math.random() * 5) + 1;
    if (provider == ProductProviderEnum.Amazon && !environment.turn_on_amazon) {
      provider = this.getRandomInt();
    } else if (provider == ProductProviderEnum.Shein && !environment.turn_on_shein) {
      provider = this.getRandomInt();
    } else if (provider == ProductProviderEnum.Walmart && !environment.turn_on_walmart) {
      provider = this.getRandomInt();
    } else if (provider == ProductProviderEnum.HomeDepot && !environment.turn_on_homedepot) {
      provider = this.getRandomInt();
    } else if (provider == ProductProviderEnum.BestBuy && !environment.turn_on_bestbuy) {
      provider = this.getRandomInt();
    }
    return provider;
  }

  showWizard() {
    const wizard = this.storageService.getAmazonWizard();
    if (!wizard) {
      this.getGoodPosition();
    } else  if ((wizard?.exp + environment.expAmazonWizard) < Date.now()) {
      this.getGoodPosition();
    }
  }

  async getGoodPosition() {
      const providerLinks = ['/market/envios/amazon-para-cuba', '/market/envios/walmart-para-cuba', '/market/envios/home-depot-para-cuba', '/market/envios/best-buy-para-cuba', '/market/envios/shein-para-cuba'];
      this.stop = true;
      const element = this.document.getElementById('show-amazon');
      const position = element.getBoundingClientRect();
      const modalRef = this.modalService.open(AmazonWizardComponent, {size: 'sm', centered: false, modalDialogClass: 'amazon-dialog-modal', backdropClass: 'background-opacity' });
      modalRef.componentInstance.top = position.y;
      modalRef.componentInstance.left = position.x;
      this.provider = providerLinks.find(x => x == this.router.url) ? this.provider$ : of(this.getRandomInt());
      modalRef.componentInstance.provider$ = this.provider;
      modalRef.result.finally(() => this.stop = false);
      this.storageService.setAmazonWizard();
  }

  async search() {
    this.store.dispatch(searchActions.KeyPressInSearch({term: this.searhControl.value}));
    const provider = await this.store.pipe(select(searchSelectors.selectProvider), take(1)).toPromise();
    if (provider>0 && this.searhControl.value.length==0){
      this.toastr.error("Debe seleccionar un término de búsqueda.");
      return;
    }
    this.store.dispatch(searchActions.SearchProducts());
  }

  async setProvider(provider: ProductProviderEnum){
    document.getElementById('search-id').focus();
    this.store.dispatch(searchActions.SetProvider({provider}));
    const prov = await this.store.pipe(select(searchSelectors.selectProvider), take(1)).toPromise();
    this.store.dispatch(searchActions.SearchProducts());
  }
  ngOnDestroy(): void {this._subscriptions.forEach(sb => sb.unsubscribe());}
}
